// extracted by mini-css-extract-plugin
export var description = "empty-attachments-module--description--84fd4";
export var title = "empty-attachments-module--title--7d588";
export var wrapper = "empty-attachments-module--wrapper--6db1f";